import React from "react";

export default function NsButtonActionsGroup({children}) {

    return (
        <div role="group"
             aria-label="Button group with nested dropdown"
             className="button-group">
            <div role="group">
                <button id="btnGroupDrop1" type="button"
                        className="btn btn-dark dropdown-toggle"
                        data-bs-toggle="dropdown" aria-expanded="false"
                        onClick={(e) => e.stopPropagation()}>
                    <i className="fa-solid fa-bars"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    {children}
                </ul>
            </div>
        </div>
    )
}
